import React, { useEffect } from "react";
import { has } from "lodash";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAuthState,
  setUserDetails,
  setUserRole,
} from "../store/globalSlice";
import AuthLoader from "./AuthLoader";

const initiateLoginFlow = (oktaAuth) => {
  const originalUri = toRelativeUrl(
    window.location.href,
    window.location.origin
  );
  oktaAuth.setOriginalUri(originalUri);
  oktaAuth.signInWithRedirect();
};

export const RequiredAuth = () => {
  const dispatch = useDispatch();
  const userDetails = useSelector((store) => store.global.user);
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated && !userDetails?.name) {
      oktaAuth.getUser().then((userInfo) => {
        const currentRole = has(userInfo, "Groups")
          ? userInfo?.Groups[0]
          : userInfo?.groups[0];
        dispatch(setUserRole(currentRole || null));
        dispatch(
          setUserDetails({
            name: userInfo?.family_name,
            uname: userInfo?.name,
            email: userInfo?.email,
            picture: null,
            id: userInfo?.sub,
          })
        );
      });
    }
  }, [oktaAuth, authState?.isAuthenticated, userDetails?.name]);

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      initiateLoginFlow(oktaAuth);
    } else {
      dispatch(
        setAuthState({
          isAuthenticated: authState?.isAuthenticated,
          id_token: authState?.idToken?.idToken,
          access_token: authState?.accessToken?.accessToken,
        })
      );
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  if (!authState || !authState?.isAuthenticated) {
    return <AuthLoader>Loading</AuthLoader>;
  }

  return <Outlet />;
};
